//#region TYPE TSupplierEmail
export type TSupplierEmail = string;
//#endregion